import userClient from '@/core/api/user-service';
import { AUTHENTICATE, LOGOUT, SET_PROFILE } from '@/core/store/types/action-types';
import { Vue, Component } from 'vue-property-decorator';

@Component
export default class ImpersonateUser extends Vue {
  secretKey = '';

  async mounted() {
    this.secretKey = this.$route.query['secret-key'] as string;
    if (!this.secretKey) {
      this.$router.replace('/login');
    } else {
      await this.$store.dispatch(LOGOUT);
      await this.impersonateCustomer();
    }
  }

  async impersonateCustomer() {
    try {
      const token = await userClient.impersonate(this.secretKey);
      await this.$store.dispatch(AUTHENTICATE, {
        token,
        authState: true,
      });
      const profile = await userClient.me();
      this.$store.dispatch(SET_PROFILE, profile);

      this.$router.replace('/');
    } catch (error) {
      let messageError = 'error';

      switch (error.status) {
        case 400:
          messageError = this.$t('badRequest').toString();
          break;
        case 404:
          messageError = this.$t('noUserFound').toString();
          break;
        default:
          messageError = this.$t('apiErrors.serverError').toString();
      }

      this.$message.error(messageError);
      this.$router.replace('/login');
    }
  }
}
